import React from 'react';
import {useTranslation} from 'react-i18next';
import {Row, Col} from 'reactstrap';
import {Select, DatePicker, ReactSelect} from '@/Form';
import {
  buildSelectOptions,
  buildMultiSelectOptions,
} from '@/components/Form/formHelper';

const PolicyAbBv = () => {
  const {t: tr} = useTranslation('selection');

  return (
    <Row>
      <Col md={12}>
        <label>{tr('report:received_date')}</label>
        <Row>
          <Col md={4}>
            <Select name='dateType'>
              {buildSelectOptions(tr('client_date_options'))}
            </Select>
          </Col>
          <Col md={2}>
            <DatePicker name='dateFrom' />
          </Col>
          <Col md={2} className='pl-1'>
            <DatePicker name='dateTo' />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <ReactSelect
              name='excludeStatus'
              label={tr('report:exclude')}
              multiple
              options={buildMultiSelectOptions(tr('exclude_status_options'))}
              hideSelectedOptions={false}
              closeMenuOnSelect={false}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default PolicyAbBv;
